var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85.78 71.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-8,.cls-9{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#e1f6fa;}.cls-4{fill:#262626;}.cls-5{fill:#606262;}.cls-6{fill:#fff;}.cls-7,.cls-8{opacity:0.9;}.cls-8,.cls-9{stroke:#3b5648;stroke-miterlimit:10;stroke-width:0px;}.cls-8{isolation:isolate;}.cls-10{fill:#ff431e;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-2 -8.06)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 88,
    height: 88
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.64,40C-5.85,27.51,4.09,4.88,22.7,12c6.24,2.65,19.16-10.7,28.67,1,5.82,7.15,9.79,3.71,22.2,1.9,14.85-1.47,23.86,31.11-3,38.76C56.86,56.28,54.87,68.82,37.11,66.12S25.14,52.41,9.64,40Z",
    transform: "translate(-2 -8.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.42,36.93c0,6.11-.09,12.22,0,18.34,0,5.59.2,11.19.11,16.78-.06,3.72-.94,7.57-7.63,7.74-2.87.07-5.63,0-8.49-.13-1.6-.1-3.75.08-5.92-.1-4.14-.35-6.21-3.26-6.29-7.57-.12-6.93-.3-38.85-.17-45.78a24,24,0,0,1,.42-5.36,4.44,4.44,0,0,1,4-3.15c4.51-.18,9-.23,13.54-.18a60.88,60.88,0,0,1,6.33.24c1.78.24,3.35.85,3.6,3.09.34,3,.45,6.28.49,9.27Q55.43,33.53,55.42,36.93Z",
    transform: "translate(-2 -8.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.18,22.62a.49.49,0,0,1,.11-.52.06.06,0,0,1,.05,0l4.83-.14c.16,0,.32,0,.48,0s.28.06.22.3.05.43-.26.39a27.77,27.77,0,0,0-4.65,0,1.64,1.64,0,0,0-.73,0A.05.05,0,0,1,38.18,22.62Z",
    transform: "translate(-2 -8.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.41,20.12a.4.4,0,0,1-.27.31l0,0a.49.49,0,0,1-.17,0,.36.36,0,0,1-.3-.28.14.14,0,0,1,0-.07.5.5,0,0,1,.32-.63H41a.39.39,0,0,1,.26.09l.06.07a.05.05,0,0,0,0,0l0,.07a.14.14,0,0,0,0,.06c0,.1,0,.17.05.26A.13.13,0,0,1,41.41,20.12Z",
    transform: "translate(-2 -8.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.05,22.71a.54.54,0,0,1-.54-.08l-.06-.05a.59.59,0,0,1-.13-.18.54.54,0,0,1,.1-.55l.07-.06a.67.67,0,0,1,.94-.08l0,.06a.51.51,0,0,1,.09.35.61.61,0,0,1,0,.12l0,.05a.22.22,0,0,1-.05.08l-.06.07a2,2,0,0,1-.26.24Z",
    transform: "translate(-2 -8.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.07,68.07c-.63-10.83.15-21.56-.44-32.39-.15-2.74-.1-4.26-.15-7,0-1.83-.19-2.37-.23-3.16,0-.95-7.93-.24-8.58-.25-4.45-.07-10,.16-14.86.29a.48.48,0,0,0-.45.39,27.82,27.82,0,0,0-.19,3.77c-.16,5.35,0,10.54-.16,15.89-.17,6.71.62,11.26.49,18.1,0,2,0,4,.15,6.75,0,.59,1.33.6,1.59.59,7-.29,15.63.5,22.65-.25a.26.26,0,0,0,.2-.27c0-1,0-.79,0-1.74Z",
    transform: "translate(-2 -8.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43.54,75.7a2.49,2.49,0,0,1-.45,1.46,1.65,1.65,0,0,1-1.44.74,2.63,2.63,0,0,1-2.37-1.29A1.92,1.92,0,0,1,39,75.54a1.24,1.24,0,0,1,.16-.59,3.47,3.47,0,0,1,1.11-1.35,1.72,1.72,0,0,1,1.27-.26,2.35,2.35,0,0,1,2,1.9C43.54,75.38,43.53,75.51,43.54,75.7Z",
    transform: "translate(-2 -8.06)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M81.56,52.3h-2",
    transform: "translate(-2 -8.06)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M75.72,40l1.7-1",
    transform: "translate(-2 -8.06)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49.94,62.21l1.7-1",
    transform: "translate(-2 -8.06)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M45.32,49.63l2,0",
    transform: "translate(-2 -8.06)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.34,38l1.53,1.26",
    transform: "translate(-2 -8.06)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M72.84,61l1.53,1.25",
    transform: "translate(-2 -8.06)"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M64.12,31.9l.12,2",
    transform: "translate(-2 -8.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M42.94,41.89a6.07,6.07,0,0,1,1,0A4.36,4.36,0,0,1,46.56,43a4.81,4.81,0,0,1,.78.9,4.43,4.43,0,0,1,.39,4.06,9,9,0,0,1-.89,1.53c-1,1.54-1.94,3.07-2.92,4.6a.64.64,0,0,1-.21.25.21.21,0,0,1-.26-.06c-.29-.42-.55-.86-.83-1.28-.91-1.46-1.87-2.89-2.79-4.35a4.65,4.65,0,0,1-.62-1.74,4.5,4.5,0,0,1,.37-2.48,4.65,4.65,0,0,1,1.55-1.8A4.39,4.39,0,0,1,42.94,41.89ZM43.1,43a3.46,3.46,0,0,0-2.84,2.87,3.67,3.67,0,0,0,.26,1.85A3.25,3.25,0,0,0,42,49.29a3.52,3.52,0,0,0,3.43-.08,3.24,3.24,0,0,0,1.39-1.74,3.36,3.36,0,0,0-1.06-3.78A3.42,3.42,0,0,0,43.9,43,4.26,4.26,0,0,0,43.1,43Z",
    transform: "translate(-2 -8.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M43.24,43.59A2.76,2.76,0,1,1,41,47.17a2.76,2.76,0,0,1,2.26-3.58Z",
    transform: "translate(-2 -8.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M36.31,44.89a.44.44,0,0,1,.49.14.45.45,0,0,1,0,.56.45.45,0,0,1-.68,0A.44.44,0,0,1,36.31,44.89Z",
    transform: "translate(-2 -8.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M37.48,45.48a.4.4,0,0,1,.3-.58h1.29c-.08.26-.11.54-.18.81-.34,0-.69,0-1,0A.43.43,0,0,1,37.48,45.48Z",
    transform: "translate(-2 -8.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M35.74,47a.39.39,0,0,1,.32-.19h2.83c0,.27.09.53.14.8H36A.41.41,0,0,1,35.74,47Z",
    transform: "translate(-2 -8.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M33.48,48.65a.43.43,0,0,1,.59.32.44.44,0,1,1-.59-.32Z",
    transform: "translate(-2 -8.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M34.81,48.73c.1-.09.24-.06.37-.07,1.44,0,2.88,0,4.32,0,.15.27.35.52.5.79h-5a.38.38,0,0,1-.27-.09A.4.4,0,0,1,34.81,48.73Z",
    transform: "translate(-2 -8.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M36.47,50.79a.4.4,0,0,1,.38-.26H40.7c.16.26.34.52.51.79H36.85a.42.42,0,0,1-.38-.24A.81.81,0,0,1,36.47,50.79Z",
    transform: "translate(-2 -8.06)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone);
export default __webpack_public_path__ + "static/media/iphone.34143d54c2810098a95877c74b8a1434.svg";
export { ForwardRef as ReactComponent };